import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

import { Media } from 'builder/styles/media'
import { Logo as LogoComponent } from 'builder/components/Logo'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 0;
  width: 100%;

  ${Media.Phone`
    padding: 24px 20px 0;
  `}
`

export const Logo = styled(LogoComponent)`
  cursor: pointer;
`

export const Link = styled.button`
  ${Typography.Body}
  ${FontWeights.Medium}

  border: none;
  cursor: pointer;
  color: ${Colors.Blue50};
`
